import { CompetitionsMatchCardSchema } from './CompetitionsMatchCard.styles';

export const competitionsMatchCardStyles: CompetitionsMatchCardSchema = {
  vsBoxWrapper: {
    position: 'relative',
    p: '1',
  },
  vsDivider: {
    borderColor: 'rgba(255, 255, 255, 0.07)',
    boxShadow: '0px -1px 0px 0px rgba(0, 0, 0, 0.20)',
  },
  absoluteCenter: {
    px: '2',
    left: '2',
    fontWeight: 'bold',
    color: 'alpha.500',
    fontSize: 'sm',
    bg: 'white',
  },
  matchCardOverride: {
    mb: '2',
    bg: 'none',
  },
  propositionButtonOverride: {
    w: '100%',
  },
  gridItem: {
    w: '100%',
  },
  flexWrapper: {
    alignItems: 'center',
  },
  flexText: {
    as: 'span',
    flex: '1',
    textAlign: 'left',
    color: 'gray.700',
    fontSize: 'sm',
    fontWeight: 'bold',
  },
  gridWrapper: {
    gap: 2,
  },
  propositionButtonOverrideSecondary: {
    w: ['50px', '100px'],
    p: '0',
  },
  gridItemTextNoProposition: {
    w: ['50px', '100px'],
    h: 'full',
    textAlign: 'center',
    color: 'blackAlpha.400',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 'xs',
    fontWeight: 'semibold',
  },
  flexAwayTeam: {
    alignItems: 'center',
  },
  flexAwayTeamText: {
    flex: '1',
    textAlign: 'left',
    color: 'gray.700',
    fontSize: 'sm',
    fontWeight: 'bold',
  },
};
